export const formatCnpj = (cnpj: string) => {
  return cnpj.replace(/([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})([0-9A-Z]{2})/i, '$1.$2.$3/$4-$5');
}

export const anonCnpj = (cnpj: string): string => {
  /* Show only 3 firsts and 3 lasts characters */
  /* Replace the others to '*' */
  const firstThree = cnpj.slice(0, 4);
  const lastThree = cnpj.slice(-3);
  const middle = cnpj.slice(4, -3);
  const regexSelectNumbers = /\d/g;
  const anonMiddle = middle.replaceAll(regexSelectNumbers, '*');
  return firstThree + anonMiddle + lastThree;

}